import React from 'react';

export const H1 = ({ children, style = {}, customClass = '', ...props }) => (
	<h1
		className={`text-3xl sm:text-4xl md:text-5xl ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</h1>
);

export const H2 = ({ children, style = {}, customClass = '', ...props }) => (
	<h2
		className={`text-2xl sm:text-3xl md:text-4xl ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</h2>
);

export const H3 = ({ children, style = {}, customClass = '', ...props }) => (
	<h3
		className={`text-xl sm:text-2xl md:text-3xl ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</h3>
);

export const H4 = ({ children, style = {}, customClass = '', ...props }) => (
	<h4
		className={`text-lg sm:text-xl md:text-2xl ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</h4>
);

export const H5 = ({ children, style = {}, customClass = '', ...props }) => (
	<h5
		className={`text-base sm:text-lg ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</h5>
);

export const H6 = ({ children, style = {}, customClass = '', ...props }) => (
	<h6
		className={`text-sm sm:text-base ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</h6>
);

export const Paragraph = ({
	children,
	style = {},
	customClass = '',
	...props
}) => (
	<p
		className={`text-sm sm:text-base mb-4 ${customClass}`}
		style={style}
		{...props}
	>
		{children}
	</p>
);

// export const Divider = styled.hr`
//   text-align: center;
//   width: 240px;
//   margin: 4em auto;
//   border: 0px solid ${colors.lightOrange};
//   background-color: ${colors.lightOrange};
// `

// export const OrderedList = styled.ol`
//   list-style: inside;
//   list-style-type: decimal-leading-zero;
//   line-height: 1.8em;
//   max-width: 660px;
//   padding-left: 1em;
//   margin: 0.8em auto;
//   li {
//     margin-bottom: 0.25em;
//   }
// `

// export const UnorderedList = styled.ul`
//   display: grid;
//   grid-gap: 0.6em;
//   list-style: inside;
//   list-style-image: url(icons/radiobtn.svg);
//   line-height: 1.8em;
//   max-width: 660px;
//   padding-left: 1em;
//   margin: 0.8em auto;
//   li {
//     margin-bottom: 0.25em;
//   }
// `

// export const Blockquote = styled.blockquote`
//   text-align: center;
//   & > p {
//     max-width: 620px;
//     text-align: center;
//     margin: 0.8em auto;
//     font-size: 1.7em;
//     line-height: 1.4em;
//     display: inline-block;
//   }
//   & ::before,
//   & ::after {
//     content: '';
//     display: block;
//     margin: 0 auto;
//     width: 3em;
//     border-top: 2px solid rgba(0, 0, 0, 0.1);
//   }
//   padding: 0.8em 0em;
// `

// export const Center = styled.p`
//   text-align: center;
//   max-width: 660px;
//   margin: 30px auto;
//   h1,
//   h2,
//   h3,
//   h4,
//   h5,
//   p {
//     text-align: center;
//   }
// `

// export const Subtext = styled.p`
//   text-align: ${props => props.center ? 'center' : 'left'};
//   max-width: 660px;
//   margin: 0 auto;
//   line-height: 1.6em;
//   font-size: 0.8em;
//   margin-top: 0.8em;
// `

// export const SmallCenter = props => {
//   return (
//     <div
//       css={css({
//         [bpMinMD]: { maxWidth: '70%' },
//         maxWidth: '100%',
//         margin: '0 auto',
//         'h1, h2, h3, h4, h5, h6, p': {
//           textAlign: 'center',
//         },
//       })}
//     >
//       {props.children}
//     </div>
//   )
// }

// export const TwoParagraph = props => {
//   return (
//     <div
//       css={css({
//         display: 'grid',
//         gridGap: '2em',
//         margin: '0 auto',
//         gridTemplateColumns: '1fr',
//         [bpMinSM]: { gridTemplateColumns: '1fr 1fr' },
//         marginTop: '2em',
//         marginBottom: '4em',
//         maxWidth: '80%',
//       })}
//     >
//       {props.children}
//     </div>
//   )
// }
